import {
  CoursesCalendarRideStatusFilter,
  CoursesCalendarRowsFilter,
} from "@ryde/shared";

import {
  CoursesCalendarRideStatusFilterLabelKeys,
  CoursesCalendarRowsFilterLabelKeys,
} from "./courses-calendar-toolbar.models";

export const COURSES_CALENDAR_TOOLBAR_SELECT_DEFAULT_MIN_WIDTH = 160;

export const COURSES_CALENDAR_TOOLBAR_SELECT_ROWS_MIN_WIDTH = 170;

export const COURSES_CALENDAR_TOOLBAR_SELECT_RIDES_MIN_WIDTH = 220;

export const COURSES_CALENDAR_TOOLBAR_SELECT_CLASS =
  "courses-calendar-toolbar-select";

export const COURSES_CALENDAR_TOOLBAR_SELECT_ROWS_CLASS = `${COURSES_CALENDAR_TOOLBAR_SELECT_CLASS} courses-calendar-toolbar-select--rows`;

export const COURSES_CALENDAR_TOOLBAR_SELECT_RIDES_CLASS = `${COURSES_CALENDAR_TOOLBAR_SELECT_CLASS} courses-calendar-toolbar-select--rides`;

export const COURSES_CALENDAR_ROWS_FILTER_E2E = "courses-calendar-rows-filter";

export const COURSES_CALENDAR_RIDE_STATUS_FILTER_E2E =
  "courses-ride-status-filter";

export const COURSES_CALENDAR_ROWS_FILTERS: readonly CoursesCalendarRowsFilter[] =
  ["all", "with_courses", "flex_only", "shuttles_only"] as const;

export const COURSES_CALENDAR_ROWS_FILTER_LABEL_KEYS: CoursesCalendarRowsFilterLabelKeys =
  {
    all: "course.calendar.rowsFilterAll",
    with_courses: "course.calendar.rowsFilterWithCourses",
    flex_only: "course.calendar.rowsFilterFlexOnly",
    shuttles_only: "course.calendar.rowsFilterShuttlesOnly",
  };

export const COURSES_CALENDAR_RIDE_STATUS_FILTERS: readonly CoursesCalendarRideStatusFilter[] =
  ["all", "created", "not_created"] as const;

export const COURSES_CALENDAR_RIDE_STATUS_FILTER_LABEL_KEYS: CoursesCalendarRideStatusFilterLabelKeys =
  {
    all: "course.calendar.rideFilterAll",
    created: "course.calendar.rideFilterProducedOnly",
    not_created: "course.calendar.rideFilterNotProducedOnly",
  };
